import { Component } from '@angular/core';

@Component({
  selector: 'opac-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent {
}
